// Initialisation après chargement du DOM
document.addEventListener('DOMContentLoaded', function() {

  // Accordéon pour la modale de compatibilité
  var acc = document.getElementsByClassName("compatibility-accordion-head");

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      var panel = this.nextElementSibling;
      var fauxCont = document.getElementById('faux_cont');

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        this.classList.remove('active');
        this.parentElement.classList.remove('abst');
        if (fauxCont) fauxCont.classList.remove('active');
      } else {
        var active = document.querySelectorAll("#compatibilityAccordion .compatibility-accordion-head.active");
        for (var j = 0; j < active.length; j++) {
          active[j].classList.remove("active");
          active[j].parentElement.classList.remove("abst");
          if (fauxCont) fauxCont.classList.remove('active');
          active[j].nextElementSibling.style.maxHeight = null;
        }

        this.classList.toggle("active");
        this.parentElement.classList.toggle('abst');
        panel.style.maxHeight = '100%';
        if (fauxCont) fauxCont.classList.toggle('active');
      }
    });
  }

  // Bouton de fermeture
  var closeBtn = document.getElementById('CloseCompatibility__modal');
  var modal = document.getElementById('compatibility_modal');

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
      console.log('Modal closed via button');
    });
  }

  // Fermer en cliquant sur le fond
  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target.id === 'compatibility_modal') {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
        console.log('Modal closed via backdrop');
      }
    });
  }

  // Handler jQuery pour #open_modal_compatibility si jQuery est disponible
  if (typeof jQuery !== 'undefined') {
    jQuery('#open_modal_compatibility').on('click', function(event) {
      event.preventDefault();
      if (modal) {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {'event_category': 'cta', 'event_label': 'compatability-e2'});
        }
      }
      return false;
    });
  }

  // Handler pour tous les liens avec href="#open-compatibility"
  var openLinks = document.querySelectorAll('a[href="#open-compatibility"]');
  for (var k = 0; k < openLinks.length; k++) {
    openLinks[k].addEventListener('click', function(e) {
      e.preventDefault();
      if (modal) {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        console.log('Modal opened via #open-compatibility link');
      }
    });
  }
});

// Fonctions globales d'ouverture
window.opencompatibilityduplicate = function() {
  var modal = document.getElementById("compatibility_modal");
  if (modal) {
    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }
};

window.opencomp1 = function() {
  var modal = document.getElementById("compatibility_modal");
  var item = document.getElementById('comp_item_1');
  if (modal) {
    modal.style.display = "flex";
    if (item) item.scrollIntoView();
    document.body.style.overflow = "hidden";
  }
};

window.opencomp2 = function() {
  var modal = document.getElementById("compatibility_modal");
  var item = document.getElementById('comp_item_2');
  if (modal) {
    modal.style.display = "flex";
    if (item) item.scrollIntoView();
    document.body.style.overflow = "hidden";
  }
};

window.opencomp3 = function() {
  var modal = document.getElementById("compatibility_modal");
  var item = document.getElementById('comp_item_3');
  if (modal) {
    modal.style.display = "flex";
    if (item) item.scrollIntoView();
    document.body.style.overflow = "hidden";
  }
};

window.opencomp4 = function() {
  var modal = document.getElementById("compatibility_modal");
  var item = document.getElementById('comp_item_4');
  if (modal) {
    modal.style.display = "flex";
    if (item) item.scrollIntoView();
    document.body.style.overflow = "hidden";
  }
};

window.opencomp5 = function() {
  var modal = document.getElementById("compatibility_modal");
  var item = document.getElementById('comp_item_5');
  if (modal) {
    modal.style.display = "flex";
    if (item) item.scrollIntoView();
    document.body.style.overflow = "hidden";
  }
};

window.opencomp6 = function() {
  var modal = document.getElementById("compatibility_modal");
  var item = document.getElementById('comp_item_6');
  if (modal) {
    modal.style.display = "flex";
    if (item) item.scrollIntoView();
    document.body.style.overflow = "hidden";
  }
};
